<template>
    <component
        :is="isTh ? 'th' : 'td'"
        class="z-table-col"
        :class="columnClass"

    >
        <template v-if="isTh">
            <span>
                <slot/>
            </span>
        </template>
        <template v-else>
            <span class="z-table-col__content">
                <slot/>
            </span>
        </template>
    </component>
</template>

<script setup>
import {computed} from 'vue'

const props = defineProps({
    index: {
        type: [String, Number]
    },
    isTh: {
        type: Boolean,
        default: false
    }
})

const columnClass = computed(() => {
    return {
        'z-table-col--head': props.isTh,
        'z-table-col--body': !props.isTh
    }
})

defineExpose({
    props
})
</script>
